//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: 'callLog',
    data() {
        return {
            callLogId: 0,//来电记录id
            // callLogDto: {}'',
            columns: [
                { type: 'index', align: 'center', maxWidth: 60 },
                { title: '来电号码', align: 'center', key: 'phone', minWidth: 125 },
                // { title: '400号码', align: 'center', key: 'customerNo' },
                { title: '工号', align: 'center', key: 'reportNum' },
                // { title: '话单', align: 'center', key: 'uqid' },
                { title: '坐席', align: 'center', key: 'workerName' },
                { title: '来电地区', align: 'center', key: 'district' },
                { title: '被叫摘机时间', align: 'center', key: 'calleeOffHookTimeStr' },
                { title: '主叫呼入时间', align: 'center', key: 'incomingTimeStr' },
                // { title: '导航按键', align: 'center', key: 'ivrKey' },
                // { title: '挂机类型', align: 'center', key: 'onHookType' },
                {
                    title: '是否生成工单', align: 'center', key: 'isCreateWorkOrder', render: (h, params) => {
                        return h('span', params.row.isCreateWorkOrder ? '是' : '否');
                    }
                },
                { title: '操作', align: 'center', key: 'onHookType', slot: 'action' }

            ],
            currentPage: 1,
            pageSize: 10,
            totalCount: 0,
            list: [],
            loading: false,
            searchInput: {},
            staffs: []
        };
    },
    computed: {},
    methods: {
        pageChange(page) {
            this.currentPage = page;
            this.getPage();
        },
        pageSizeChange(size) {
            this.pageSize = size;
            this.getPage();
        },
        getPage() {
            // const params = {
            //     maxResultCount: this.pageSize,
            //     skipCount: (this.currentPage - 1) * this.pageSize
            // };
            this.searchInput.maxResultCount = this.pageSize;
            this.searchInput.skipCount = (this.currentPage - 1) * this.pageSize;
            this.loading = true;
            abp.ajax.get('/api/services/app/CallLogs/GetUserCallLogs', { params: this.searchInput }).then(res => {
                this.list = [];
                this.list.push(...res.data.result.items);
                this.totalCount = res.data.result.totalCount;
            }).finally(() => {
                this.loading = false;
            });
        },
        show(row) {
            this.$router.push({
                name: 'callLogDetail',
                params: {
                    callLogId: row.id
                }
            });
        },
        handleReset() {
            this.searchInput = {};
            this.pageChange(1);
        },

        getStaffs() {
            const page = {
                'maxResultCount': 20,
                'skipCount': 0
            };
            abp.ajax.post('/api/services/app/CallLogs/SearchStaffs', page).then(res => {
                this.staffs = [];
                this.staffs.push(...res.data.result.items);
            }).finally(() => {

            });
        },
        hasPermission(permission) {
            return abp.auth.isGranted(permission);
        }

    },
    created() {
        this.getStaffs();
        this.getPage();
    }
};
